import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Contextmenu-item element, used for each individual item in the contextmenu element
 *
 * @slot - Unnamed slot (default slot)
 *
 * @prop {String} icon - optional, used to display a Fontawesome icon
 *
 */
let SDBContentContextMenuItem = class SDBContentContextMenuItem extends LitElement {
    constructor() {
        super(...arguments);
        this.icon = '';
    }
    render() {
        return html `
            <li>
                ${this.icon
            ? html `<div class="contextMenuIcon">
                          <sdb-content-icon
                              size="24"
                              .icon=${this.icon}
                          ></sdb-content-icon>
                      </div>`
            : html ``}
                <slot></slot>
            </li>
        `;
    }
};
SDBContentContextMenuItem.styles = [
    elements,
    css `
            :host li {
                width: 100%;
                padding: 1em 18px;
                display: inline-block;
                /* white-space: pre; */
                box-sizing: border-box;
                display: block;
                width: 100%;
                list-style: none;
                color: var(--text-primary);
                font-weight: 300;
                font-size: 0.9em;
                line-height: 25px;
            }

            :host li:hover {
                background: var(--element-lightgrey);
            }

            .contextMenuIcon {
                display: block;
                margin-right: 10px;
                float: left;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentContextMenuItem.prototype, "icon", void 0);
SDBContentContextMenuItem = __decorate([
    customElement('sdb-content-contextmenu-item')
], SDBContentContextMenuItem);
export { SDBContentContextMenuItem };
//# sourceMappingURL=sdb-content-contextmenu-item.js.map